import endpoints from "../models/api/api.endpoints";
import api from "../helpers/api.service";
import Helper from "../helpers/helper.service";
import ServiceResponseCode from "../models/service.response.code";

export default {
  async getUsuarioLista(
      page = null,
      pageSize = null,
      pesquisaUsuario = null,
      idTipoUsuario = null,
      idCurso = null,
      idDisciplina = null,
      somenteProfessor = null,
      idFranqueadoUnidade = null
  ) {
    try {
      const params = [
        {
          Name: 'page',
          Value: page
        },
        {
          Name: 'pageSize',
          Value: pageSize
        },
        {
          Name: 'pesquisaUsuario',
          Value: pesquisaUsuario
        },
        {
          Name: 'idTipoUsuario',
          Value: idTipoUsuario
        },
        {
          Name: 'idDisciplina',
          Value: idDisciplina
        },
        {
          Name: 'idCurso',
          Value: idCurso
        },
        {
          Name: 'somenteProfessor',
          Value: somenteProfessor
        },
        {
          Name: 'idFranqueadoUnidade',
          Value: idFranqueadoUnidade
        }
      ]
      const url = `${endpoints.usuario}/list${Helper.getURLParams(params)}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async getUsuario(id) {
    try {
      const url = `${endpoints.usuario}/${id}`;
      const result = await api.get(url)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async registerUsuario(data, method) {
    try {
      const result = (method == 'criar') ?
        await api.post(endpoints.usuario, data) :
        await api.put(endpoints.usuario, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async alterarSenha(data) {
    try {
      const url = `${endpoints.usuario}/alterar-senha`
      const result = await api.put(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async deslogarUsuario(id) {
    try {
      const url = `${endpoints.usuario}/deslogar`
      const result = await api.put(url, { Id: id })
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  },
  async atualizarConfiguracoes(data) {
    try {
      const url = `${endpoints.usuario}/configuracoes`
      const result = await api.put(url, data)
      return Helper.getServiceResponse(result)
    } catch (e) {
      return {
        Code: ServiceResponseCode.CatchAPICall,
        Title: 'Error',
        Message: e.message,
        Success: false,
      }
    }
  }
}
